'use strict';

export default function routes($stateProvider) {
  'ngInject';

  $stateProvider.state('oem_main.device_config_edit', {
    url: '/company/:company_id/device_config_edit/:id',
    template: '<oem-device-config-edit></oem-device-config-edit>'
  });
};



// WEBPACK FOOTER //
// ./public/dev/app/oem/device_config/edit/device_config_edit.routes.js